export default __webpack_public_path__ + "static/media/353b1fb77b3ceebc30fbf9a9d55ebe4d.png";